import { writable, readable, derived } from 'svelte/store';

export const assetUrl = writable('');
export const maxDemoWidth = writable(false);
export const linkToAppointment = writable('');
export const language = writable('de');

export const startTime = writable('');

export const mainStep = writable(0);

export const delayShort = readable(300);
export const delayMedium = readable(400);
export const delayLong = readable(1200);

export const prefix = readable('x818973c5df76821320be3bb174285ef4');

export const i18n = writable({});


export let quizLogoURL = derived([i18n, language], ([$i18n, $language])=> {
    if($i18n && $i18n[$language]) {
        return $i18n[$language].quizLogo;
    }
    return "./images/dailymed-logo.png";
});

export let backBtn = derived([i18n, language], ([$i18n, $language])=> {
    if($i18n && $i18n[$language]) {
        return $i18n[$language].backBtn;
    }
    return "./images/dailymed-logo.png";
});

export let questions = derived([i18n, language], ([$i18n, $language])=> {
    if($i18n && $i18n[$language]) {
        return $i18n[$language].questions;
    }
    return [];
});

export let stepQuestion = derived([i18n, language, mainStep], ([$i18n, $language, $mainStep])=> {
    if($i18n && $i18n[$language] && $i18n[$language].questions) {
        return $i18n[$language].questions[$mainStep];
    }
    return {};
});

export let resultsI18N = derived([i18n, language], ([$i18n, $language])=> {
    if($i18n && $i18n[$language]) {
        return $i18n[$language].results;
    }
    return [];
});

export let intakeTimes = derived(language, ($language) => {
    const i18n = {
        "de": {
            "schedules": {
                "morning": "morgens",
                "midday": "mittags",
                "evening": "abends",
                "night": "nachts"
            },
            "times": {
                "morning": "07:00",
                "midday": "12:00",
                "evening": "18:00",
                "night": "23:00"
            }
       },
       "fr": {
            "schedules": {
                "morning": "morgens",
                "midday": "mittags",
                "evening": "abends",
                "night": "nachts"
            },
            "times": {
                "morning": "07:00",
                "midday": "12:00",
                "evening": "18:00",
                "night": "23:00"
            }
        }
    }
    return i18n[$language];
});


